import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, effect } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

import { AccountService } from 'src/app/core/api/services';
import { UserSessionService } from 'src/app/core/services/authentication/user-session.service';
import { AuthTokenService } from '../services/authentication/auth-token.service';
import { AppConfigService } from '../services/config.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  isUpdatingRefreshToken = false;

  constructor(
    private accountService: AccountService,
    private userSession: UserSessionService
  ) {
    effect(() => {
      this.isUpdatingRefreshToken = this.userSession.isUpdatingRefreshToken();
    });
  }

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //get token
    const token = AuthTokenService.getAccessToken();
    const apiUrl = AppConfigService.config.apiUrl;
    const requestUrl = httpRequest.url.replace(apiUrl, '');

    //   if(['/Notifications/GetNotificationsList','/Menus/GetAsideMenus','/Users/GetUserState']
    //   .includes(requestUrl)){
    //     httpRequest = httpRequest.clone({
    //       setHeaders: { Authorization: 'Bearerfff ' + `${token}` }
    //     });
    //   }
    //  else if (token) {
    //     httpRequest = httpRequest.clone({
    //       setHeaders: { Authorization: 'Bearer ' + `${token}` }
    //     });
    //   }

    if (token && requestUrl != '/CustomerDomains/GetCurrentClientData') {
      httpRequest = httpRequest.clone({
        setHeaders: { Authorization: 'Bearer ' + `${token}` },
      });
    }

    return next
      .handle(httpRequest)
      .pipe(
        catchError((err) => {
          return throwError(() => err);
        })
      )
      .pipe(
        map<HttpEvent<any>, any>((res: HttpEvent<any>) => {
          if (res instanceof HttpResponse) {
            const needRefreshToken = res.headers.has('x-rft');

            if (
              needRefreshToken &&
              +needRefreshToken > 0 &&
              !this.isUpdatingRefreshToken
            ) {
              const refreshToken = AuthTokenService.getRefreshToken();
              this.userSession.setUpdatingRefreshToken(true);

              //RefreshToken
              const subscription = this.accountService
                .accountUpdateRefreshToken({
                  body: { refreshToken: refreshToken },
                })
                .pipe(
                  finalize(() => {
                    this.userSession.setUpdatingRefreshToken(false);
                  })
                )
                .subscribe((res) => {
                  if (res.isSucceed) {
                    AuthTokenService.setRefreshToken(
                      res.data.refreshToken,
                      AuthTokenService.isRememberMe()
                    );
                    subscription.unsubscribe();
                  }
                });
            }
          }
          return res;
        })
      );
  }
}

export const HttpTokenInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
];
